<template>
  <CompactProfileCard :profile="profile" customizable class="gmf-context" />
</template>

<script>
import CompactProfileCard from '@/components/CompactProfileCard';
import state from '@/state';

export default {
  components: { CompactProfileCard },
  
  data() {
    return {
      state
    }
  },

  computed: {
    profile() {
      return this.state.profile;
    }
  }
};
</script>
